import * as React from 'react';
import { Badge, BadgeProps } from 'ui/badge/badge';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactBadgeProps {
  badgeProps: BadgeProps;
  section?: number;
  [key: string]: any;
}
export const RiskFactItem = (props: FactBadgeProps) => {
  const { riskArea, riskTrend, riskWeight, url, title, hideRiskWeight, linkDomain, portalTarget } = props;
  const riskProps = {
    title: riskArea ? title : undefined,
    tooltip: riskArea?.description,
    text: !hideRiskWeight ? riskWeight : '',
    filled: true,
    backgroundColor: riskArea?.backgroundColor,
    foregroundColor: riskArea?.foregroundColor,
    riskTrend: { value: riskTrend?.[0]?.value, description: riskTrend?.[0]?.description, icon: riskTrend?.[0]?.icon }
  };

  if (!riskWeight) {
    return null;
  }
  return (
    <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
      <Badge
        {...riskProps}
        portalTarget={portalTarget}
      />
    </FactLink>
  );
};
